import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import PhoneField from 'components/v2/forms/PhoneField';
class LocationContact extends Component {
    constructor() {
        super(...arguments);
        this.handleNameChange = (e) => this.props.onContactChange('name', e.target.value);
        this.handlePhoneChange = (phone) => this.props.onContactChange('phone', phone);
    }
    render() {
        const { contact: { name, phone }, t, } = this.props;
        return (React.createElement("div", { className: "grid grid-cols-2 gap-4" },
            React.createElement("div", { className: "", id: "contact-details" },
                React.createElement("label", { className: "form-label mb-1" }, t('CONTACT_NAME')),
                React.createElement("input", { type: "text", className: "form-field", placeholder: t('JOHN_SMITH'), onChange: this.handleNameChange, value: name, id: "contact" })),
            React.createElement("div", { className: "", id: "phone-details" },
                React.createElement("label", { className: "form-label mb-1" }, t('CONTACT_PHONE')),
                React.createElement(PhoneField, { value: phone, onChange: this.handlePhoneChange, id: "phone" }))));
    }
}
LocationContact.propTypes = {
    onContactChange: PropTypes.func.isRequired,
    contact: PropTypes.shape({
        name: PropTypes.string,
        phone: PropTypes.string,
    }),
};
LocationContact.defaultProps = {
    contact: {
        name: '',
        phone: '',
    },
};
export default withTranslation()(LocationContact);
